import React, { useEffect, } from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'reactstrap';
import { isEmpty, pick, } from 'lodash';
import { setDoc, updateDoc, limit, query, where, orderBy, collection, doc, } from 'firebase/firestore';
import { httpsCallable, } from 'firebase/functions';
import { format as formatDate } from 'date-fns';
import numeral from 'numeral';
import { keyBy } from 'lodash';
import { toast } from 'react-toastify';
import qs from 'qs';

import firebase, { db, batch, functions, getCollectionData, } from '../../firebase';
import env from '../../env';
import { fields, } from '../../shared/models/product';
import useQueryParams from '../hooks/useQueryParams';
import useCollectionSubscription from '../hooks/useCollectionSubscription';
import ModelFormModal from '../modals/ModelFormModal';
import EditButton from '../EditButton';
import DeleteButton from '../DeleteButton';
import AddButton from '../AddButton';
import ProgressButton from '../ProgressButton';
import TenantPage from '../TenantPage';
import useTenant from '../hooks/useTenant';

const getAdApiAuthUrl = httpsCallable(functions, 'getAdApiAuthUrl');
const pullAdProfiles = httpsCallable(functions, 'pullAdProfiles');

export default function Products (props) {
  return (
    <TenantPage>
      <PageContent {...props} />
    </TenantPage>
  );
};

function PageContent (props) {
  const { tenant, history, location, } = props;
  const queryParams = useQueryParams();
  const sellers = useCollectionSubscription(query(collection(tenant.ref, 'sellers')));
  const sellersById = keyBy(sellers, 'id');
  const products = useCollectionSubscription(query(collection(tenant.ref, 'products')));

  return (
    <div className="products container-fluid">
      <div className="px-4">
        <div className="card p-4">
          <div className="mb-3 d-flex justify-content-start align-items-end gap-1">
          </div>
          <table className="table table-bordered">
            <thead className="thead-light text-nowrap">
              <tr>
                <th style={{ minWidth: 250 }}>ショップ</th>
                <th style={{ minWidth: 150 }}>ASIN</th>
                <th style={{ minWidth: 150 }}>SKU</th>
                <th style={{ minWidth: 250 }}>商品名</th>
                <th style={{ minWidth: 70 }}></th>
              </tr>
            </thead>
            <tbody>
              {
                products.map(({ id, ref, sku, amazonAttributes, name, sellerId, }) => {
                  const seller = sellersById[sellerId];

                  return (
                    <tr key={id} id={id}>
                      <td>
                        [{sellerId}] {seller?.name}
                      </td>
                      <td>
                        {amazonAttributes?.asin}
                      </td>
                      <td>
                        {sku}
                      </td>
                      <td>
                        {name}
                      </td>
                      <td>
                      </td>
                    </tr>
                  );
                })
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
